import React from 'react';

const LOGO_URL = '/woss-publishing-assets/images/woss-publishing-logo-white.svg';

// See Header.jsx — routed cross-app by the load balancer, not an internal route.
const CLIENT_PORTAL_URL = '/auth/login';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="padding-global">
        <div className="container-large">
          <div className="footer_component">
            <div className="footer_content">
              <div className="footer_title">
                <h2 className="heading-style-h2">
                  Ready to work with us? <span className="text-light">&amp;</span> join the roster
                </h2>
              </div>
              <div className="footer_contact">
                <div className="max-width-xsmall">
                  <p data-load-text="" className="text-size-md">
                    Reach out about your songs and catalog. We support songwriters,
                    producers, artists, and catalog owners.
                  </p>
                </div>
                <a href="mailto:global@wosspublishing.com" className="footer_contact-email">
                  <span data-load-text="">global@wosspublishing.com</span>
                </a>
              </div>
            </div>
            <div className="footer_links">
              <div className="footer_legal-links">
                <div className="footer_brand">
                  <div data-load-text="">
                    <img
                      src={LOGO_URL}
                      alt="Woss Publishing"
                      style={{ height: '1.5rem', width: 'auto' }}
                    />
                  </div>
                </div>
                <div className="footer_template-links">
                  <a data-load-text="" href="/#who-we-are" className="footer_template-link">Who We Are</a>
                  <a data-load-text="" href="/#roster"     className="footer_template-link">Roster</a>
                  <a data-load-text="" href="/#synch"      className="footer_template-link">Synch</a>
                  <a data-load-text="" href="/#contact"    className="footer_template-link">Contact</a>
                  <a data-load-text="" href={CLIENT_PORTAL_URL} className="footer_template-link">Portal</a>
                  <a data-load-text="" href="/legal/terms"   className="footer_template-link">Terms of Use</a>
                  <a data-load-text="" href="/legal/privacy" className="footer_template-link">Privacy Policy</a>
                </div>
              </div>
              <div className="footer_copyright">
                <span data-load-text="" className="text-size-sm">
                  &copy; {year} Woss Publishing. All rights reserved.
                </span>
                <span data-load-text="" className="text-size-sm">
                  Part of the Woss Music ecosystem.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
